module.exports = __webpack_public_path__ + "img/steady-laptop.6cd15e0d.jpg";